import { VisitMedicalImaging } from '@dreryk/egabinet-visit-frontend-api';

import { StyledFlex, TestableComponentProps } from '@dreryk/react-components';

import { VisitHistoryMedicalImagingItem } from './VisitHistoryMedicalImagingItem';

type VisitMedicalImagingSectionProps = TestableComponentProps & {
   readonly visitMedicalImagings: VisitMedicalImaging[];
};

export const VisitHistoryMedicalImagingSection = (props: VisitMedicalImagingSectionProps): JSX.Element => {
   const { visitMedicalImagings } = props;

   return (
      <StyledFlex direction={'column'} gap={12}>
         {visitMedicalImagings.map((visitMedicalImaging) => (
            <VisitHistoryMedicalImagingItem
               key={visitMedicalImaging.medicalInformationId}
               visitMedicalImaging={visitMedicalImaging}
            />
         ))}
      </StyledFlex>
   );
};
